import { render, staticRenderFns } from "./TaxCatalog.vue?vue&type=template&id=0393f384"
import script from "./TaxCatalog.vue?vue&type=script&lang=js"
export * from "./TaxCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0393f384')) {
      api.createRecord('0393f384', component.options)
    } else {
      api.reload('0393f384', component.options)
    }
    module.hot.accept("./TaxCatalog.vue?vue&type=template&id=0393f384", function () {
      api.rerender('0393f384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxCatalog.vue"
export default component.exports